// myipb
import myipb from './../../../img/myipb-01.svg'

//Variables

function TopApps() {

    return (
        <div>
            <a className='myipbButton' href='https://my.ipb.pt' target='_blank' rel="noreferrer">
                <img src={myipb} alt='MyIPB logo' />
            </a>
        </div>
    )
}

export default TopApps
